import Chip from "@mui/material/Chip";
import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import { nmsMenus } from "globals/configuration/nms";

const Attributes = {
  formSize: "lg",
  columns: 3,
  enableAddButton: true,
  ButtonNames: "Multiple Asset Delete",
  enableMultipleDeleteButton: true,
  enableUploadFaxButton: true,
  enableUploadButton: true,
  enableDownloadButton: true,
  modes: nmsMenus.map((item) => ({
    id: item.key,
    name: item.name,
    iconName: item.icon,
    url: item.url,
    description: item.description,
    disabled: item.disabled,
    productionReady: item.productionReady,
  })),
  messages: {
    success: "Updated successfully",
    error: "Unable to update data",
  },
  settingsMode: false,
};

const operationURLS = {
  list: "deviceManager/getall",
  update: "deviceManager/update",
  create: "deviceManager/create",
  delete: "deviceManager/delete",
  // #9420: generated SEP XML preview / manual override / clear-reset / state
  previewXml: "deviceManager/cisco/xml/preview",
  saveXmlOverride: "deviceManager/cisco/xml/override",
  clearXmlOverride: "deviceManager/cisco/xml/clear",
  xmlState: "deviceManager/cisco/xml/state",
};

const getColumns = (
  onDelete,
  onEdit,
  onUpdateConfiguration,
  onUpdateFirmware,
  onReboot,
  onEditXml
) => {
  return [
    {
      Header: "S.No",
      accessor: "serial",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row }) => row.index + 1,
    },
    {
      Header: "MAC Address",
      accessor: "macAddress",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      controlType: "input",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Extension",
      accessor: "extensionNumber",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      controlType: "input",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Model",
      accessor: "model",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      controlType: "input",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Manufacturer",
      accessor: "manufacturer",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      controlType: "input",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      // #9420: highlight devices whose SEP XML has been manually edited (protected from bulk overwrite)
      Header: "Manual Edit",
      accessor: "xmlManuallyEdited",
      displayInList: true,
      allowInForm: false,
      Cell: ({ value }) =>
        value ? (
          <Chip label="Manually Edited" color="warning" size="small" />
        ) : (
          <DefaultCell value={"-"} />
        ),
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
          onUpdateConfiguration={onUpdateConfiguration}
          onEditXml={onEditXml}
          onUpdateFirmware={onUpdateFirmware}
          onReboot={onReboot}
        />
      ),
    },
  ];
};

export { getColumns, Attributes, operationURLS };